import { api } from '@/services'

export async function calculateFreightRequest(id: string, zipcode: string) {
  try {
    const { data } = await api.post('Cart/CalcularFreteCarrinho', null, {
      params: {
        CheckoutId: id,
        cep: zipcode
      }
    })

    return { data }
  } catch (error) {
    console.error(error)
  }
}
